import React, { useRef } from "react";

/**
 * Date field with native calendar picker. Visible value is always YYYY-MM-DD;
 * a transparent type="date" overlay captures clicks and opens the picker.
 */
const YmdDateInput = ({
  value = "",
  onChange,
  name,
  id,
  disabled = false,
  min,
  max,
  className = "",
  "aria-label": ariaLabel,
}) => {
  const pickerRef = useRef(null);

  const openPicker = () => {
    if (disabled) return;
    const el = pickerRef.current;
    if (!el) return;
    if (typeof el.showPicker === "function") {
      el.showPicker();
    } else {
      el.focus();
      el.click();
    }
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={value}
        readOnly
        placeholder="YYYY-MM-DD"
        disabled={disabled}
        className={`pointer-events-none w-full ${className}`}
        tabIndex={-1}
        aria-hidden="true"
      />
      <input
        ref={pickerRef}
        type="date"
        name={name}
        id={id}
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        onChange={onChange}
        onClick={openPicker}
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
        aria-label={ariaLabel || "Select date (YYYY-MM-DD)"}
      />
    </div>
  );
};

export default YmdDateInput;
